module.exports = __webpack_public_path__ + "img/serve.53fea539.png";